import { useState } from 'react';
import { useMediaQuery } from 'react-responsive';

import ActiveMessage from './ActiveMessage';
import { MessageContainerStyled } from './style';
import UserList from './UserList';

export type VisibleScreenType = 'chatList' | 'conversation';

const Message = () => {
  const isMobileView = useMediaQuery({ query: `(max-width:700px)` });
  const [visibleScreen, setVisibleScreen] =
    useState<VisibleScreenType>('chatList');

  const handleSetVisibleScreen = (value: VisibleScreenType) => {
    setVisibleScreen(value);
  };

  return isMobileView ? (
    {
      chatList: <UserList changeVisibleScreen={handleSetVisibleScreen} />,
      conversation: (
        <ActiveMessage changeVisibleScreen={handleSetVisibleScreen} />
      ),
    }[visibleScreen]
  ) : (
    <MessageContainerStyled>
      <UserList />
      <ActiveMessage />
    </MessageContainerStyled>
  );
};

export default Message;
